import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { generateRoute, setBaseAppUrl } from './utils/location';
import { AppMarketPageIdentifier, APP_MARKET_ROUTES } from './AppRoutes';
import { AppMode } from './models/enums';
import { NotFound } from './pages/NotFound';
import { useAppMode } from './hooks/useAppMode';

/**
 * Checkout out the nested routes and Outlet component
 * More info at: https://reactrouter.com/docs/en/v6/getting-started/tutorial
 */
export const AppMarketRouter: React.FC = (): JSX.Element => {
  let { path: appPath, url } = useRouteMatch();
  const { i18n } = useTranslation();
  const appMode = useAppMode();
  setBaseAppUrl(url); // this will set base url in the sessionStorage, which will be later used to navigate

  const routes = useMemo(() => {
    return APP_MARKET_ROUTES.map((route, index) => {
      let { path, exact, privateRouteOnly, isUsOnly, routes: subRoutes } = route;
      path = `${appPath}${path}`;
      return (
        <Route
          key={path}
          path={path}
          exact={exact}
          render={(props) => {
            if ((!isUsOnly || i18n.language === 'en-US') && (appMode === AppMode.Private || !privateRouteOnly)) {
              return (
                <>
                  {/*Pass sub routes down to the component to keep nesting*/}
                  {route.component ? <route.component {...props} routes={subRoutes} appMode={appMode} /> : <NotFound />}
                </>
              );
            } else {
              return <Redirect
                to={{ pathname: generateRoute(AppMarketPageIdentifier.Home), state: { from: props.location.pathname } }} />;
            }
          }}
        />
      );
    });
  }, [appMode, i18n, appPath]);

  return (
    <Switch>
      {routes}
    </Switch>
  );
};
